/**
 * Whether `AuthInterceptor` would attach the Curafida access token to this URL.
 *
 * Keycloak, Directus, the white-label extra assets and the public webshop endpoints are either a
 * different auth domain or deliberately anonymous, so they are always sent unauthenticated.
 *
 * Shared with the global error handler so that both sides agree on what counts as a public request:
 * a 401 answered by a URL we never authenticated cannot be repaired by refreshing our token.
 */
export function isBackendRequest(url: string): boolean {
    return !(
        url.includes('realms') ||
        url.includes('directus') ||
        url.includes('assets/extra') ||
        url.includes('/webshop/therapy/public/')
    );
}
